import { default as GenericInput } from './Generic';

export default GenericInput;